import url from '@/utils/config';
import React, { ReactNode } from 'react';

type Props = {
  id?: string;
  variant: 'primary' | 'secondary';
  href: string;
  children: ReactNode;
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
  ariaLabel?: string;
};

/**
 * 外部サイト遷移用のボタン見た目リンク。
 * @param props 見た目、遷移先、無効化状態などの設定
 * @returns 外部リンクボタン
 */
const ExternalLinkButton = ({
  id,
  variant,
  href,
  children,
  disabled = false,
  ariaLabel,
}: Props) => {
  // 無効時は見た目だけ残し、外部サイトへの遷移を止める。
  const onClickAnchor = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) event.preventDefault();
  };

  return (
    <a
      id={id}
      className={`m-button__inner ${variant === 'secondary' ? 'm-button--sec' : ''} ${
        disabled ? 'disabled' : ''
      }`}
      href={disabled ? '' : href}
      onClick={onClickAnchor}
      target='_blank'
      rel='noreferrer'
      aria-label={ariaLabel}
    >
      <span className='m-button__txt'>{children}</span>
      {/* 外部ウィンドウ遷移であることが分かる専用アイコンを使う。 */}
      <img
        className='m-button__icon'
        src={url('/images/icon_blank_white.svg')}
        alt='別ウィンドウで開きます'
      />
    </a>
  );
};
ExternalLinkButton.defaultProps = {
  id: undefined,
  ariaLabel: undefined,
};

export default ExternalLinkButton;
